module.exports = __webpack_public_path__ + "img/eclipse.3431e16c.svg";